module.exports = __webpack_public_path__ + "static/media/dentist-color.9c7eba37.svg";